import React from 'react';
import { Button, Checkbox, Form, Input, Select, Switch } from 'antd';
import { openNotification, toTurkishUpper } from '../../../utils';
import { apiFetch } from 'services/apiClient';
import { createMeasuringInstrument, updateMeasuringInstrument, getMeasuringInstrument } from '../services/measuring-instrumentService';
import { CreateMeasuringInstrumentDto } from '../types/MeasuringInstrument';

export default function MeasuringInstrumentForm({ id, onSuccess, referenceId }: { id?: number; onSuccess: () => void; referenceId?: number }) {
  const [form] = Form.useForm<CreateMeasuringInstrumentDto>();
  
  const [attributeOptions, setAttributeOptions] = React.useState<any[]>([]);
  const selectedAttrIds = Form.useWatch('attributes', form) as any[] | undefined;
  React.useEffect(() => {
    if (id) {
      getMeasuringInstrument(id).then(d => { const data: any = { ...d }; if (data.attributes) data.attributes = data.attributes.map((o: any) => o.id ?? o); form.setFieldsValue(data); });
    } else {
      form.resetFields();
      form.setFieldsValue({ isActive: true });
    }
    apiFetch('/attributes?isActive=true').then(setAttributeOptions);
  }, [id, form]);
  const onFinish = async (values: CreateMeasuringInstrumentDto) => {
    const data: any = { ...values };
    data.name = toTurkishUpper(values.name)?.trim() ?? values.name;
    if (data.attributes) data.attributes = data.attributes.map((id: any) => id);
    try {
      if (id) {
        await updateMeasuringInstrument(id, data);
        openNotification('success', 'Başarılı', 'Ölçüm Cihazı Güncellendi');
      } else {
        await createMeasuringInstrument(data);
        openNotification('success', 'Başarılı', 'Ölçüm Cihazı Eklendi');
      }
      onSuccess();
    } catch (e) {
      openNotification('error', 'Hata', 'Ölçüm Cihazı işlemi başarısız');
    }
  };
  return (
    <>
      
      <Form form={form} onFinish={onFinish} layout='vertical' initialValues={{ isActive: true }}>
      <Form.Item name='name' label='Cihaz Adı' rules={[{ required: true }]}>
        <Input style={{ width: '100%', textTransform: 'uppercase' }} lang='tr' />
      </Form.Item>
      <Form.Item name='isActive' valuePropName='checked' label='Aktif/Pasif'>
        <Switch checkedChildren='Aktif' unCheckedChildren='Pasif' />
      </Form.Item>
      <Form.Item name='attributes' label='Parametre'>
        <Select
          mode='multiple'
          showSearch
          filterOption={(input, option) => ((option?.children?.toString()) || '').toLocaleLowerCase('tr').includes(input.toLocaleLowerCase('tr'))}
          placeholder='Seçiniz'
          style={{width:'100%'}}
        >
          {(attributeOptions || [])
            .filter((o: any) => {
              const isActive = o?.isActive === undefined ? true : !!o.isActive;
              const selected = Array.isArray(selectedAttrIds) && selectedAttrIds.includes(o?.id);
              // Only list active; but keep previously selected even if inactive
              return isActive || selected;
            })
            .map((o: any) => (
              <Select.Option key={o.id} value={o.id}>{o.name ?? o.id}</Select.Option>
            ))}
        </Select>
      </Form.Item>
      <Button htmlType='submit' type='primary' block>Kaydet</Button>
    </Form>
    </>
  );
}
